import { render } from "./EdicionClientesRecomendadosView.vue?vue&type=template&id=772c3c23"
import script from "./EdicionClientesRecomendadosView.vue?vue&type=script&lang=js"
export * from "./EdicionClientesRecomendadosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__